import { useEffect } from 'react'

const nativeTimeline = () =>
  typeof CSS !== 'undefined' &&
  CSS.supports &&
  CSS.supports('animation-timeline', 'view()')

/**
 * Fallback reveal for browsers without scroll-driven animations.
 * Where `animation-timeline` is supported the CSS handles everything and
 * this hook does no work at all — no observer, no listeners.
 */
const useScrollReveal = (key) => {
  useEffect(() => {
    if (nativeTimeline()) return

    const targets = document.querySelectorAll('.reveal:not(.is-visible)')
    if (!targets.length) return

    if (!('IntersectionObserver' in window)) {
      targets.forEach((el) => el.classList.add('is-visible'))
      return
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible')
            observer.unobserve(entry.target)
          }
        })
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    )

    targets.forEach((el) => observer.observe(el))

    return () => observer.disconnect()
  }, [key])
}

export default useScrollReveal
